module.exports = __webpack_public_path__ + "img/qrcode.de6e34b3.png";